module.exports = __webpack_public_path__ + "img/bala_reading_explanation.6bcd0fde.png";